import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const BlocCcms = ({ ccms, status }) => {

    if (status === 'loading') {
        // Skeleton Loading State
        return (
            <div className="container space-bloc">
                <div className="row">
                    {/* Colonne gauche */}
                    <div className="col-md-5">
                        <h2>
                            <Skeleton width="60%" height={30} />
                        </h2>
                        <p>
                            <Skeleton width="90%" height={20} count={3} />
                        </p>
                    </div>

                    {/* Colonne droite */}
                    <div className="col-md-7">
                        <div className="skeleton-accordion">
                            {[...Array(5)].map((_, index) => (
                                <div key={index} style={{ marginBottom: '20px' }}>
                                    <Skeleton width="80%" height={25} />
                                    <Skeleton width="95%" height={15} style={{ marginTop: '10px' }} />
                                    <Skeleton width="90%" height={15} style={{ marginTop: '5px' }} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

            </div>
        );
    }

    // Render State
    if (status !== 'loading' && ccms) {
        return (
            <div className="container space-bloc bloc-ccm">
                <div className="row">
                    {/* Colonne gauche */}
                    <div className="col-md-6">
                        <img
                            src={`${process.env.REACT_APP_FILE_URL}${ccms?.banner_image}`}
                            alt={ccms?.title}
                            className="bloc-featured"
                        />
                    </div>

                    {/* Colonne droite */}
                    <div className="col-md-6 pl-50">
                        <h2 className='grey500 pb-40 title-size'>{ccms?.title}</h2>
                        {ccms?.steps?.map((element, index) => (
                        <div className="elem-flex" key={index}>
                            <div className={`elem-ccm ${index !== ccms.steps.length - 1 ? "border-b" : ""}`}>
                            <span>{element?.order}</span>
                            <div>
                                <h3>{element?.title}</h3>
                                <p className="">{element?.description}</p>
                            </div>
                            </div>
                        </div>
                        ))}

                    </div>
                </div>
                <div className='row p-27'>
                    <div className='col-md-4 text-center mx-auto'>
                        <div className='icon'>
                            <img
                                src={`${process.env.REACT_APP_FILE_URL}${ccms?.icon1}`}
                                alt={ccms?.title}
                                className="bloc-featured"
                            />
                        </div>
                        <p>{ccms?.text1}</p>
                    </div>
                    <div className='col-md-4 text-center mx-auto'>
                        <div className='icon'>
                            <img
                                src={`${process.env.REACT_APP_FILE_URL}${ccms?.icon2}`}
                                alt={ccms?.title}
                                className="bloc-featured"
                            />
                        </div>
                        <p>{ccms?.text2}</p>
                    </div>
                    <div className='col-md-4 text-center mx-auto'>
                        <div className='icon'>
                            <img
                                src={`${process.env.REACT_APP_FILE_URL}${ccms?.icon3}`}
                                alt={ccms?.title}
                                className="bloc-featured"
                            />
                        </div>
                        <p>{ccms?.text3}</p>
                    </div>
                </div>
            </div>
        );
    }

    // Fallback
    return null;
};

export default BlocCcms;
